import type { ComponentCommonDownloadableContentList } from '@edwin-group/cj-graphql/generated/graphql';
import icon from '@/assets/downloadable-content.png';
import defaultIconHeader from '@/assets/downloads.svg';
import classNames from 'classnames';

function DownloadableContent({
  component,
  className,
  isDefaultContentTemplate = false,
  title,
  iconHeader,
}: {
  component?: ComponentCommonDownloadableContentList;
  className?: string;
  title?: string;
  isDefaultContentTemplate?: boolean;
  iconHeader?: string;
}) {
  if (component?.list?.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(`rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5`, {
        className,
        'my-0': isDefaultContentTemplate,
        'my-sh-5': !isDefaultContentTemplate,
      })}>
      <div className="mb-sh-15 flex items-center gap-sh-15">
        <img src={iconHeader || defaultIconHeader} alt="" className="size-[38px]" />
        <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{title || 'Downloads'}</h3>
      </div>
      <ul key={`downloadable`} className="!m-0 !p-0">
        {component?.list?.map((c) => (
          <li key={c?.id} className="flex flex-col !pb-4 pl-0 text-sh-sm last:!pb-0">
            <a
              href={c!.content!.data!.attributes!.url!}
              rel="noreferrer"
              target="_blank"
              className="flex items-center font-bold text-black-100">
              <img src={icon} className="mr-1" alt="downloadable icon" />
              {c?.title}
            </a>
            <ol className="!m-0 !pl-6 text-sh-xxs">{c?.description}</ol>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DownloadableContent;
